import { useEffect, useMemo, useRef, useState } from "react";
import {
  createLinkedinInvitation,
  createLinkedinMessage,
  createSMS,
  getLinkedinInvitations,
  getLinkedinMessages,
  getSMS,
} from "../../api/ModelsApi";
import {
  Button,
  Divider,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  TextInput,
} from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { getFields } from "../../api/ContactAPI";
import { useConfigStore } from "../../stores/ConfigStore";
import TextEditor from "../ExternalEditors/TextEditor";
import { notifications } from "@mantine/notifications";

const MessagePreviewerEditable = ({ paperStyle, onFinish, type }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const editorRef = useRef();

  const datafields = useConfigStore((s) => s.datafields);
  const datafieldTokens = useMemo(() => {
    let df = datafields.map((x) => ({
      label: x.name,
      value: x.identifier_placeholder,
    }));

    df = [
      {
        label: lang.components.variable_manager.dialog.signature_variable_name,
        value: "%signature%",
        name: lang.components.variable_manager.dialog.signature_variable_name,
      },
      {
        label:
          lang.components.variable_manager.dialog.unsubscribe_variable_name,
        value: "%unsubscribe%",
        name: lang.components.variable_manager.dialog.unsubscribe_variable_name,
      },
      {
        label: lang.components.variable_manager.dialog.webversion_variable_name,
        value: "%webversion%",
        name: lang.components.variable_manager.dialog.webversion_variable_name,
      },

      ...df,
      {
        label: lang.components.variable_manager.dialog.b64_variable_name,
        value: "%email_b64%",
        name: lang.components.variable_manager.dialog.b64_variable_name,
      },
    ];

    return df;
  }, [datafields, lang]);
  console.log(type);

  const onSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    let text = "";

    text = editorRef?.current?.getContent({ format: "text" }) || "text";

    let func;
    if (type === "linkedin_invitation") func = createLinkedinInvitation;
    if (type === "linkedin_message") func = createLinkedinMessage;
    if (type === "sms") func = createSMS;

    setLoading(true);
    return func({
      name: `Draft - ${new Date().toLocaleDateString()}`,
      text,
      sender: data.sender,
    })
      .then((response) => {
        let newId = response.data.model_id;

        let getFunc;
        if (type === "linkedin_invitation") getFunc = getLinkedinInvitations;
        if (type === "linkedin_message") getFunc = getLinkedinMessages;
        if (type === "sms") getFunc = getSMS;

        getFunc()
          .then((res) => {
            let newItemsList = res.data.models_list;
            let newItem = newItemsList.find((x) => x.id === newId);
            notifications.show({
              title: lang.models.created,
              message: lang.models.created_text,
              color: "tertiary.8",
            });
            onFinish?.(newItem);
          })
          .finally(() => {
            setLoading(false);
          });
        onFinish?.(newId);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    getFields().finally(() => {
      setLoading(false);
    });
  }, []);

  return (
    <Stack
      pos={"relative"}
      h={"100%"}
      flex={1}
      component={"form"}
      onSubmit={onSubmit}
      gap={"xs"}
    >
      <LoadingOverlay visible={loading} />
      <Paper component={Stack} h={"100%"} flex={1} gap={0} {...paperStyle}>
        {type === "sms" && (
          <TextInput
            label={lang.components.email_preview.sender}
            placeholder={lang.components.email_preview.sender}
            name="sender"
            w="50%"
            required
            maxLength={11}
            minLength={4}
            mb={8}
            size="md"
          />
        )}

        <TextEditor
          editorRef={editorRef}
          placeholder={lang.model_emails.create.dialog.placeholder}
          tokens={datafieldTokens}
          autoFocus={false}
          maxChars={
            type === "linkedin_message" ? 3000 : type === "sms" ? 160 : 500
          }
          toolbar={"undo redo | tokens |"}
          longVariableButton
        ></TextEditor>
      </Paper>
      <Group justify="center">
        <Button
          leftSection={<IconDeviceFloppy size={18} />}
          loading={loading}
          type="submit"
        >
          {lang.model_emails.create.dialog.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default MessagePreviewerEditable;
